const Color = {
  // 主色
  primary: '#343F99',
  primaryDark: '#2E3889',
  secondary: '#F8AB42',
  secondaryDark: '#DE993B',
  // 警告色
  success: '#00C389',
  successDark: '#00AF7B',
  warning: '#F8AB42',
  warningDark: '#DE993B',
  error: '#FA6400',
  errorDark: '#CA1C1C',
  // 图表色
  one: '#343F99',
  two: '#86D4E0',
  three: '#F8AB42',
  threeDark: '#78BEC9',
  four: '#FA6400',
  five: '#00C389',
  six: '#44D7B6',
  seven: '#CCC',

  // other
  bodyBg: '#F4F4F4',
  dark: '#38415E',
  C19: '#191919',
  fff: '#FFF',
  white: '#FFF',
  cyan: '#00C389',
  red: '#E02020',
  ccc: '#CCC',
  c333: '#333',
  c666: '#666',
  c999: '#999',
  c70: '#702082',
  f4: '#4284F4',
  f0: '#f0f0f0',
  f4f4: '#F4F4F4',
  c55: '#485259',
  cf: '#CFCFCF',
  da: '#9DA2B0',
  f7: '#F7F8FB',
  e04: '#E04120 ',

  gold: '#F8AB42',
  silver: '#999999',
  copper: '#D55500',
  other: '#CCC',
  ec: '#ECECEC',
  f1: '#F1F1F1',
  d9: '#D9D9D9',
  c000: '#000',
  f76b: '#f76b1c',
  c389: '#00C389',
  c87: '#878787',


  midColor: (opacity: number) => `rgba(224, 65, 32, ${opacity})`,
  blackColor: (opacity: number) => `rgba(0, 0, 0, ${opacity})`,
  whiteColor: (opacity: number) => `rgba(255, 255, 255, ${opacity})`,
  errorColor: (opacity: number) => `rgba(224, 32, 32, ${opacity})`,
  primaryColor: (opacity: number) => `rgba(52, 63, 153, ${opacity})`,
  secondaryColor: (opacity: number) => `rgba(248, 171, 66, ${opacity})`,
  redColor: (opacity: number) => `rgba(248, 171, 66, ${opacity})`,
  c70Color: (opacity: number) => `rgba(112, 32, 130, ${opacity})`,
  f4Color: (opacity: number) => `rgba(66, 132, 244, ${opacity})`,
  twoColor: (opacity: number) => `rgba(134, 212, 224, ${opacity})`,
  successColor: (opacity: number) => `rgba(0,195,137, ${opacity})`,

  goldColor: (opacity: number) => `rgba(248, 171, 66, ${opacity})`,
  silverColor: (opacity: number) => `rgba(153, 153, 153, ${opacity})`,
  copperColor: (opacity: number) => `rgba(213, 85, 0, ${opacity})`,
  otherColor: (opacity: number) => `rgba(204, 204, 204, ${opacity})`,
  c55Color: (opacity: number) => `rgba(72, 82, 89, ${opacity})`,
  d9Color: (opacity: number) => `rgba(157, 162, 176, ${opacity})`,

  color01: (opacity: number) => `rgba(52, 63, 153, ${opacity})`,
  color02: (opacity: number) => `rgba(248, 171, 66, ${opacity})`,
  color03: (opacity: number) => `rgba(134, 212, 224, ${opacity})`,
  color04: (opacity: number) => `rgba(250, 100, 1, ${opacity})`,
  color05: (opacity: number) => `rgba(157, 162, 176, ${opacity})`,
  color06: (opacity: number) => `rgba(133, 218, 50, ${opacity})`,
  color07: (opacity: number) => `rgba(73, 121, 215, ${opacity})`,
  color08: (opacity: number) => `rgba(112, 32, 130, ${opacity})`,
  color09: (opacity: number) => `rgba(182, 100, 210, ${opacity})`,
  color10: (opacity: number) => `rgba(0, 195, 137, ${opacity})`,
  color11: (opacity: number) => `rgba(255, 82, 82, ${opacity})`,
  color12: (opacity: number) => `rgba(204, 204, 204, ${opacity})`,
};

export default Color;
